export enum BookingDisabledOption {
  ADMIN = 'ADMIN',
  BAN = 'BAN',
  STORNO = 'STORNO',
  MISTAKE = 'MISTAKE',
  BLACK_LISTED = 'BLACK_LISTED',
}
